export const ALIS = "alis";
export const SATIS = "satis";
export const EXTENSION_DATA = "extensionData";
export const ITEMS = [
  { name: "ceyrek_altin", title: "Çeyrek Altın" },
  { name: "yarim_altin", title: "Yarım Altın" },
  { name: "tam_altin", title: "Tam Altın" },
  { name: "kafali_2_5lu", title: "Kafalı 2.5lu Altın" },
  { name: "cumhuriyet_ata", title: "Ata Lira (Cumhuriyet)" },
  { name: "bilezik", title: "Bilezik" },
  { name: "gram_1", title: "1 Gram" },
  { name: "gram_0_5", title: "0.5 Gram" },
  { name: "gram_0_25", title: "0.25 Gram" },
  { name: "gram_0_10", title: "0.10 Gram" },
  { name: "gram_0_05", title: "0.05 Gram" },
  { name: "24_ayar_gram_1", title: "24 Ayar Gram" },
];
export const CURRENCIES = [];
/* export const CURRENCIES = [
   {name:'dolar',title:'Dolar'},
   {name:'euro',title:'Euro'}
] */



// WEBPACK FOOTER //
// ./src/constants.js